import { render } from "./SizeFilters.vue?vue&type=template&id=d192cf80"
import script from "./SizeFilters.vue?vue&type=script&lang=js"
export * from "./SizeFilters.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__